export default function mapNestedObjects(obj, nestedKey, newNestedKey, transform, depth = 0) {
    if (Array.isArray(obj)) {
        return obj.map((item) => mapNestedObjects(item, nestedKey, newNestedKey, transform, depth + 1));
    }

    if (typeof obj === "object" && obj !== null) {
        const mappedObj = { ...obj };
        if (mappedObj.hasOwnProperty(nestedKey)) {
            mappedObj[newNestedKey] = mapNestedObjects(mappedObj[nestedKey], nestedKey, newNestedKey, transform, depth + 1);
            delete mappedObj[nestedKey]; // Remove the old nested key
        }
        return transform(mappedObj, depth);
    }
    return obj;
}
